import { type Enum } from '@webapp/infrastructure/types/Enum'

// Export staging lifecycle of a record relative to QuickBooks Desktop.
// Values are the sub-status tab route segments AND the list endpoint
// path segments ({resource}/{status}/ v2; /api/v3/item_receipts/{status}/).
export const QuickBooksExportStatuses = {
  EXPORTABLE: 'exportable', // Eligible for export; selectable for stage/archive
  EXPORTED: 'exported', // Already exported; read-only
  ARCHIVED: 'archived', // Archived; selectable for unarchive
} as const

export type QuickBooksExportStatus = Enum<typeof QuickBooksExportStatuses>
